import { render, staticRenderFns } from "./NewEmployeeEducations.vue?vue&type=template&id=52da1f92&scoped=true&"
import script from "./NewEmployeeEducations.vue?vue&type=script&lang=js&"
export * from "./NewEmployeeEducations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da1f92",
  null
  
)

export default component.exports